import React, { useReducer, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import CustomAlert from '../../componentes/alerts/CustomAlert';
import GridInputRow from '../../componentes/form-grids/GridInputRow';
import { Grid } from '@material-ui/core';
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import { DefaultDatagrid } from '../../componentes/datagrid/DefaultDatagrid';
import InputField from "../../componentes/form-fields/InputField/InputField";
import { BaseButton } from "../../componentes/baseComponents/BaseButton"
import { BaseDialog } from "../../componentes/baseComponents/base-dialog/BaseDialog"
import RelatorioEntregasService from "./RelatorioEntregasService";



const RelatorioEntregasDialog = ({ _idEntrega, openDialog, handleCloseDialog }) => {
    const { t } = useTranslation();
    const { control } = useForm();
    const idUsulogado = sessionStorage.getItem("userId");

    const initialState = {
        numeroNota: "",
        nomeCliente: "",
        dataNota: null,
        dataImportacaoNota: null,
        cidadeEnderecoCliente: "",
        ufEnderecoCliente: "",
        qtdeProdutoLido: "",
        qtdeProdutoRequerido: "",
        qtdeVolume: 0,
        rows: []
    };

    const columnsRelatorioEntregas = (t) => [
        {
            field: "numeroNFe",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="numeroNfe" />;
            },
        },
        {
            field: "nomeCliente",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="nomeCliente" />;
            },
        },
        {
            field: "dataNota",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="dataNota" />;
            },
        },
        {
            field: "dataImportacaoNota",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="dataImportacaoNota" />;
            },
        },
        {
            field: "cidadeEnderecoCliente",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="city" />;
            },
        },
        {
            field: "ufEnderecoCliente",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="uf" />;
            },
        },
        {
            field: "qtdeVolumes",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="lblNumeroVolume" />;
            },
        },
        {
            field: "idProduto",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="idProduct" />;
            },
        },
        {
            field: "descProduto",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="descProd" />;
            },
        },
        {
            field: "qtdeProdutoRequerido",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="qtdeProdutoRequerido" />;
            },
        },
        {
            field: "qtdeProdutoLido",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="qtdeProdutoLido" />;
            },
        },
    ];


    function reducer(state, action) {
        switch (action.type) {
            case "update": {
                return {
                    ...state,
                    ...action.payload
                };
            }
            case "clear": {
                return initialState;
            }
            case "error": {
                return {
                    ...state,
                    success: false,
                    error: true,
                    message: action.message
                };
            }
            case "close_alert": {
                return {
                    ...state,
                    success: false,
                    error: false
                };
            }
            default:
                throw new Error(`Invalid reducer action type: ${action.type}!`);
        }
    }

    const [state, dispatch] = useReducer(reducer, initialState);
    const { success, error, message, numeroNota, nomeCliente, dataNota, dataImportacaoNota, cidadeEnderecoCliente, ufEnderecoCliente, qtdeVolume, qtdeProdutoLido, qtdeProdutoRequerido, rows } = state;


    function setError(message) {
        dispatch({ type: "error", message });
    }

    function handleCloseAlert() {
        dispatch({ type: "close_alert" });
    }

    function handleChange(event) {
        dispatch({
            type: "update",
            payload: { [event.target.name]: event.target.value || event.target.checked }
        });
    }

    function handleSearch() {
        const request = {
            idEntregaCliente: _idEntrega
        };

        RelatorioEntregasService.getDialogData(request)
            .then((response) => {
                debugger
                dispatch({
                    type: "update",
                    payload: {
                        rows: response.data,
                        numeroNota: response.data[0].numeroNFe,
                        nomeCliente: response.data[0].nomeCliente,
                        dataNota: response.data[0].dataNota,
                        qtdeVolume: response.data[0].qtdeVolumes,
                        cidadeEnderecoCliente: response.data[0].cidadeEnderecoCliente,
                        ufEnderecoCliente: response.data[0].ufEnderecoCliente,
                        qtdeProdutoLido: response.data[0].qtdeProdutoLido,
                        qtdeProdutoRequerido: response.data[0].qtdeProdutoRequerido,
                    }
                });
            })
            .catch(() => setError(t("searchError")));
    }

    function handleClear() {
        dispatch({ type: "clear" });
    }

    useEffect(() => {
        if (openDialog) {
            handleSearch();
        }
    }, [openDialog]);



    return (
        <>
            <CustomAlert
                success={success}
                error={error}
                message={message}
                handleCloseAlert={handleCloseAlert}
                snackbar
                autoClose
            />

            <BaseDialog
                open={openDialog}
                onClose={() => handleCloseDialog(false)}
                fullWidth
                maxWidth="lg"
                style={{
                    maxHeight: "80vh", // Ajuste a altura máxima do diálogo
                }}
                title={t("relatorioEntrega")}
                content={
                    <>
                        <DefaultScreenAccordion

                            fields={
                                <DefaultDatagrid
                                    columns={columnsRelatorioEntregas(t,)}
                                    dataSource={rows}
                                    Export
                                />
                            } />
                    </>
                }
            />
        </>
    );
};

export default RelatorioEntregasDialog;
